import React from 'react'

const SelectField = ({
    name,
    label,
    options,
    value,
    onChange,
    onBlur,
    error,
    touched,
    defaultValue,
    disabled,
}: {
    name: string
    label?: string
    options: { value: string | number; label: string }[]
    value: string | number
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
    onBlur: (e: React.FocusEvent<HTMLSelectElement>) => void
    error: string | undefined
    touched: boolean | undefined
    defaultValue?: string | number
    disabled?: boolean
}) => {
    return (
        <div className="form mb-3">
            {label && <label>{label}</label>}
            <select
                className="form-control form-select mt-2"
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                defaultValue={defaultValue}
                disabled={disabled}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            {error && touched && <div style={{ color: 'red' }}>{error}</div>}
        </div>
    )
}

export default SelectField
